import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { Form } from '@unform/web';
import { useDispatch, useSelector } from 'react-redux';
import { subDays, addDays, format, getTime, getDate } from 'date-fns';
import pt from 'date-fns/locale/pt';
import { toast } from 'react-toastify';
import { FiSearch } from 'react-icons/fi';

import api from 'services/api';
import { updateCurrentDate } from 'store/modules/usuario/actions';

import Input from 'components/Input';
import Card from 'components/Card';
import SelectDate from 'components/SelectDate';
import Tooltip from 'components/Tooltip';
import Flag from 'components/Flag';
import Loader from 'components/ContentLoader/ComerciaisNaoGravadosLoader';

import { Scroll } from 'styles/global';
import { Container, Table, Td } from './styles';

export default function ComerciaisGravados() {
  /**
   * REDUX
   * */
  const dispatch = useDispatch();
  const { emissora, currentDate } = useSelector(state => state.usuario);

  /*
   * VARIAVEIS
   */

  const [loading, setLoading] = useState(true);
  const [globoExpress, setGloboExpress] = useState([]);

  /**
   * USE MEMO
   */

  const dateFormatted = useMemo(() => {
    if (currentDate) {
      return format(new Date(currentDate), "d 'de' MMMM", { locale: pt });
    }
  }, [currentDate]);

  /**
   * FUNÇÕES
   */

  const handlePrevDay = useCallback(() => {
    dispatch(updateCurrentDate(subDays(new Date(currentDate), 1)));
  }, [currentDate, dispatch]);

  const handleNextDay = useCallback(() => {
    dispatch(updateCurrentDate(addDays(new Date(currentDate), 1)));
  }, [currentDate, dispatch]);

  const handleDateChange = useCallback(
    date => {
      date && dispatch(updateCurrentDate(date));
    },
    [dispatch],
  );

  /**
   * USE EFFECT
   */
  useEffect(() => {
    async function loadGloboExpress() {
      setLoading(true);
      try {
        const response = await api.get(
          `/emissoras/${emissora.value}/globoexpress`,
          { params: { date: getTime(new Date(currentDate)) } },
        );
        setGloboExpress(
          response.data.globoExpress.map(c => ({ ...c, loading: false })),
        );
        setLoading(false);
      } catch (error) {
        toast.error(error.message);
        setLoading(false);
      }
    }
    loadGloboExpress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDate, emissora.value]);

  // }, [currentDate, currentDateZoned, emissora.value]);

  return (
    <Container>
      <header>
        <div />
        <SelectDate
          dateFormatted={dateFormatted}
          currentDateZoned={new Date(currentDate)}
          handleNextDay={handleNextDay}
          handlePrevDay={handlePrevDay}
          handleDateChange={handleDateChange}
          disabledNextDay={
            getDate(new Date(currentDate)) === getDate(new Date())
          }
        />
        <div />
      </header>
      <Card>
        <header>
          <h4>COMERCIAIS GLOBO EXPRESS</h4>

          <div>
            <Form onSubmit={() => {}}>
              <Input
                name="searchLocal"
                disabled
                placeholder="Buscar na Tabela"
                icon={<FiSearch />}
              />
            </Form>
          </div>
        </header>
        {loading ? (
          <Loader />
        ) : (
          <Scroll>
            <Table>
              <thead>
                <tr>
                  <th>CM</th>
                  <th>TITULO</th>
                  <th>STATUS</th>
                </tr>
              </thead>

              <tbody>
                {!!globoExpress &&
                  globoExpress.map(ge => (
                    <tr key={ge.id}>
                      <Td size="5">{ge.comercial.codmaterial}</Td>
                      <Td size="30">{ge.comercial.titulo}</Td>
                      <Td size="5">
                        <Flag
                          type={ge.statusgeral.type}
                          name={ge.statusgeral.nome}
                        >
                          <Tooltip>
                            <p>
                              <strong>{ge.statusgeral.info}</strong>
                            </p>
                          </Tooltip>
                        </Flag>
                      </Td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Scroll>
        )}
      </Card>
    </Container>
  );
}
